<template>
  <dl class="kv">
    <template v-for="(item, i) in items">
      <dt :key="'k-' + i">{{ item.k }}</dt>
      <dd :key="'v-' + i" :class="{ 'kv-mono': item.mono }">{{ item.v }}</dd>
    </template>
  </dl>
</template>

<script>
/**
 * Reusable key-value list leaf.
 *
 * Renders a two-column grid of dt/dd pairs. The `mono` flag on an item
 * switches that value cell to the monospace font (used for codes like
 * `SUP-12345`, drawing refs, model versions).
 *
 * Styles mirror the Claude Design wireframe `.kv` block
 * (AVA Verification Wireframe.html lines 101-104).
 */
export default {
  name: 'KeyValueList',
  props: {
    items: {
      type: Array,
      required: true,
      // Expected item shape: { k: String, v: String, mono?: Boolean }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/verification-tokens';

.kv {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 8px 10px;
  font-size: 12.5px;
  margin: 0;

  dt {
    color: $vf-ink-2;
    font-weight: 400;
  }

  dd {
    margin: 0;
    color: $vf-ink;
    font-weight: 500;

    // `.kv-mono` instead of bare `.mono` — avoids colliding with any
    // global `.mono` utility and makes the modifier semantically scoped.
    &.kv-mono {
      font-family: $vf-font-mono;
      font-size: 11.5px;
    }
  }
}
</style>
